import view from 'ramda/src/view'
import pathOr from 'ramda/src/pathOr'
import lensPath from 'ramda/src/lensPath'

import { formStoreLenses } from 'root/src/client/logic/form/lenses'

const {
	pathOrFieldErrors, pathOrFieldData, viewFormSubmitted,
} = formStoreLenses

export default	(state, { moduleKey, fieldPath }) => (
	// is form submitted
	viewFormSubmitted(moduleKey, state)
			// is field dirty
			|| view(
				lensPath([...fieldPath, 'dirty']),
				pathOrFieldData(moduleKey, {}, state),
			)
		? pathOr(
			'',
			fieldPath,
			pathOrFieldErrors(moduleKey, {}, state),
		) : ''
)
